import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RemoteService } from 'app/services/remote.service';
import { NotifierService } from 'angular-notifier';
import { LocalStorageService } from 'ngx-store';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPassword: FormGroup;
  formSumitAttempt: boolean;
  constructor(private fb: FormBuilder,
    private remoteService: RemoteService,
    private notifierService: NotifierService,
    private ls: LocalStorageService) { }

  ngOnInit() {
    this.forgotPassword = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9A-Z.!#$%^&+;*_)(-]{3,}[@]{1}[a-z]{2,}[.]{1}[a-z]{2,}$')]]
    })
    this.remoteService.scrollingtoNavbar();
    if (this.ls.get('access_token')) {
      return this.remoteService.userNavigateTodashboard();
    }
  }

  sendEmail() {
    if (this.forgotPassword.valid) {
      const payload = {
        email: this.forgotPassword.value.email
      }
      this.remoteService.forgotPassword(payload).subscribe(res => {
        const data = {
          text: 'Click on link sent to your email to change the password',
        }
        this.remoteService.openSweetAlert(data);
      }, (error) => {
        this.remoteService.errorFunction(error);
      })
    } else {
      this.notifierService.notify('error', 'Invalid Inputs!');
    }
  }

  isFieldValid(field: string) {
    return (
      (!this.forgotPassword.get(field).valid && this.forgotPassword.get(field).touched) ||
      (this.forgotPassword.get(field).untouched && this.formSumitAttempt)
    );
  }

  onSubmit() {
    this.formSumitAttempt = true;
  }
}
